export const COUNTER_INCREMENT = 'COUNTER_INCREMENT'
export const COUNTER_DECREMENT = 'COUNTER_DECREMENT'

export const increment = () => ({
  type: COUNTER_INCREMENT as typeof COUNTER_INCREMENT
})

export const decrement = () => ({
  type: COUNTER_DECREMENT as typeof COUNTER_DECREMENT
})

export type CounterActionType = ReturnType<typeof increment> | ReturnType<typeof decrement>
